var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocument3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.563,
    height: 21,
    viewBox: "0 0 16.563 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Document-3",
    d: "M7.02,8.171h7.249a.58.58,0,0,0,.435-.178.607.607,0,0,0,.173-.44.575.575,0,0,0-.173-.424.59.59,0,0,0-.435-.172H7.02a.619.619,0,0,0-.45.172.567.567,0,0,0-.178.424.6.6,0,0,0,.178.44A.608.608,0,0,0,7.02,8.171Zm0,3.363h7.249a.58.58,0,0,0,.435-.178.606.606,0,0,0,.173-.44.575.575,0,0,0-.173-.424.59.59,0,0,0-.435-.172H7.02a.619.619,0,0,0-.45.172.568.568,0,0,0-.178.424.6.6,0,0,0,.178.44A.608.608,0,0,0,7.02,11.533Zm0,3.363h3.466a.606.606,0,0,0,.439-.172A.568.568,0,0,0,11.1,14.3a.608.608,0,0,0-.617-.618H7.02a.608.608,0,0,0-.45.178.6.6,0,0,0-.178.44.568.568,0,0,0,.178.424A.619.619,0,0,0,7.02,14.9ZM2.354,20.253a3.185,3.185,0,0,0,.782,2.339,3.128,3.128,0,0,0,2.315.786H15.82a3.125,3.125,0,0,0,2.319-.786,3.2,3.2,0,0,0,.777-2.339V5.512a3.214,3.214,0,0,0-.777-2.343,3.114,3.114,0,0,0-2.319-.791H5.45a3.117,3.117,0,0,0-2.315.791,3.2,3.2,0,0,0-.782,2.343Zm1.758-.079V5.591a1.476,1.476,0,0,1,.369-1.08,1.471,1.471,0,0,1,1.1-.375H15.694a1.485,1.485,0,0,1,1.1.375,1.476,1.476,0,0,1,.369,1.08V20.174a1.307,1.307,0,0,1-1.473,1.455H5.576a1.471,1.471,0,0,1-1.1-.375A1.476,1.476,0,0,1,4.112,20.174Z",
    transform: "translate(-2.354 -2.378)",
    fill: "#333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument3);
export default __webpack_public_path__ + "static/media/Document-3.39f45f1ffb93cd78401f677163023f1b.svg";
export { ForwardRef as ReactComponent };